import React from 'react';
import { MdCall, MdWhatsapp, MdEmail } from 'react-icons/md';

export default function ServiceDetailLayout({
  hero,
  highlights,
  timeline,
  extra,
}) {
  return (
    <div className="service-page">
      <section className="service-hero">
        <div className="service-hero__content">
          <p className="eyebrow">{hero.kicker}</p>
          <h1>{hero.title}</h1>
          <p className="service-hero__subtitle">{hero.subtitle}</p>
          <p className="service-hero__copy">{hero.description}</p>
          {hero.chips && (
            <div className="service-hero__chips">
              {hero.chips.map((chip) => (
                <span key={chip} className="service-chip">
                  {chip}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="service-hero__visual">
          <img src={hero.image} alt={hero.title} />
          <div className="service-hero__badge">Modern compliance desk</div>
        </div>
      </section>

      <section className="service-highlights">
        {highlights.map((item) => (
          <article key={item.title} className="service-card">
            <div className="service-card__icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.detail}</p>
          </article>
        ))}
      </section>

      <section className="service-timeline">
        <div className="service-timeline__header">
          <h2 className="service-timeline__title">How we operate</h2>
          <p className="text-muted">Structured checkpoints keep you in control.</p>
        </div>
        <div className="service-timeline__steps">
          {timeline.map((step, index) => (
            <div key={step.title} className="service-step" data-step={index + 1}>
              <h4>{step.title}</h4>
              <p>{step.detail}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="service-cta">
        <div>
          <p className="eyebrow">Ready to chat?</p>
          <h3>{extra.ctaTitle}</h3>
          <p>{extra.ctaCopy}</p>
        </div>
        <div className="service-cta__actions">
          <a href="tel:+255758779913" className="btn btn-primary">
            <MdCall size={20} /> Call
          </a>
          <a href="https://wa.me/255758779913" target="_blank" rel="noreferrer" className="btn btn-secondary">
            <MdWhatsapp size={20} /> WhatsApp
          </a>
          <a href="mailto:efiling@werenium.com" className="btn btn-outline-dark">
            <MdEmail size={20} /> Email
          </a>
        </div>
      </section>
    </div>
  );
}
